const errorColor = "#d32f2f";
const focusedBorderColor = "#72abe5";
const defaultBorderColor = "#e5e7eb";
const inputFieldBG = "#F5F9FF";
const inputFieldDisabledBG = "#d3d3d39e";
const disabledText = "#7e8491";


const styles = {
  inputStyle: (disabled, error, isFocused) => ({
    width: "100%",
    borderRadius: "8px",
    fontFamily: "Kanit",
    fontSize: "14px",
    paddingTop: "10px",
    height: "40px",
    paddingBottom: "10px",
    paddingLeft: "45px",
    backgroundColor: disabled ? inputFieldDisabledBG : inputFieldBG,
    color: disabled ? disabledText : "black",
    transition: "border-color 0.3s ease",

    // Specify individual border properties
    borderTopWidth: "3px",
    borderTopStyle: "solid",
    borderTopColor: error ? errorColor : isFocused ? focusedBorderColor : defaultBorderColor,

    borderLeftWidth: "3px",
    borderLeftStyle: "solid",
    borderLeftColor: error ? errorColor : isFocused ? focusedBorderColor : defaultBorderColor,

    borderBottomWidth: "3px",
    borderBottomStyle: "solid",
    borderBottomColor: error ? errorColor : isFocused ? focusedBorderColor : defaultBorderColor,

    borderRightWidth: "3px",
    borderRightStyle: "solid",
    borderRightColor: error ? errorColor : isFocused ? focusedBorderColor : defaultBorderColor,
  }),
// buttonStyles   
  buttonStyle: (error, isFocused) => ({
    borderTopWidth: "3px",
    borderTopStyle: "solid",
    borderTopColor: error ? errorColor : isFocused ? focusedBorderColor : defaultBorderColor,

    borderLeftWidth: "3px",
    borderLeftStyle: "solid",
    borderLeftColor: error ? errorColor : isFocused ? focusedBorderColor : defaultBorderColor,

    borderBottomWidth: "3px",
    borderBottomStyle: "solid",
    borderBottomColor: error ? errorColor : isFocused ? focusedBorderColor : defaultBorderColor,

    borderRightWidth: "3px",
    borderRightStyle: "solid",
    borderRightColor: error ? errorColor : isFocused ? focusedBorderColor : defaultBorderColor,
  }),
//   container-style
  containerStyle: {
    borderRadius: "8px",
    backgroundColor: "white",
    width: "100%",
  },
//   dropdown-style
  dropdownStyle: {
    color: "black",
    borderRadius: "8px",
    backgroundColor: "#fff",
  },
};

export { styles };
